import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { GLOBAL_IMAGES } from "../../assets/asset";
import UseAuthToken from "../../hooks/useAuthToken";
import { SkeletonYears } from "../../utils/SkeletonLoader";
import Header from "../Years/YearsHeader";
import "../../App.css";

const YearSelection = () => {
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const token = UseAuthToken();
  const [userName, setUserName] = useState("Your");

  useEffect(() => {
    if (!token) return;

    setUserName(JSON.parse(localStorage.getItem("user"))?.user_name);

    const fetchYears = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}api/allyears`,
          {
            headers: {
              Authorization: `${process.env.REACT_APP_AUTH_TOKEN_DEV}`,
              "Content-Type": "application/json",
              jwt: token,
            },
          }
        );
        const extractedYears = response.data.data.map((item) => ({
          name: item.fields.year,
          id: item.pk,
        }));
        setYears(extractedYears);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchYears();
  }, [token]);

  const handleYearClick = (yearId) => {
    navigate("/lessonDashboard", { state: { yearId } });
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-blue-50 font-mali"
      style={{
        backgroundImage: `url(${GLOBAL_IMAGES.onboarding_bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute top-0 w-full">
        <Header />
      </div>
      <div className="flex flex-col items-center space-y-8 w-full px-4">
        <p className="text-black text-center text-4xl md:text-5xl font-bold leading-none">
          Select {userName}'s Math grade
        </p>
        <p
          title="We curate learning experience based on the grade and assessment"
          className="text-black text-center font-bold leading-none text-lg md:text-2xl"
        >
          We will curate {userName}'s learning experience based on the grade and
          assessment
        </p>
        <div
          className="w-full flex justify-center py-6 gap-5 items-center px-5"
          style={{
            backgroundColor: "#975113",
            maxWidth: "70%",
            borderRadius: "10px",
          }}
        >
          <img
            alt="!"
            src={GLOBAL_IMAGES.exclamationMark}
            className="h-9 self-center"
          />
          <p className="text-white text-center text-sm md:text-xl">
            You can always go back and change the math grade of your child from
            settings, if you feel you need to change the grade.
          </p>
        </div>
        {loading && <SkeletonYears />}
        {error && <p className="text-red-500">Error: {error}</p>}
        {!loading && !error && (
          <div className="w-[70%] mx-auto overflow-x-auto scrollable-hide-scrollbar  h-[13rem]">
            <div className="flex space-x-10 py-4 w-max mx-auto">
              {years.map((year, index) => (
                <div
                  key={year.id}
                  className={`w-24 h-24 md:w-36 md:h-36 flex items-center justify-center rounded-full cursor-pointer bg-red-400 ${
                    index % 2 === 0 ? "relative -top-4" : "relative top-10"
                  }`}
                  style={{
                    backgroundImage: `url(${GLOBAL_IMAGES.yearContainerImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    flexShrink: 0,
                  }}
                  onClick={() => handleYearClick(year.id)}
                >
                  <p className="text-white font-bold text-center text-sm md:text-xl">
                    {year.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default YearSelection;
